import React from 'react';

import { ServiceOSLogin } from '../../ServiceOS/ServiceOSLogin/ServiceOSLogin';
import { THeaderMobileProps } from '../Header.types';
import { HeaderBasket } from '../HeaderBasket/HeaderBasket';
import { HeaderNav } from '../HeaderNav/HeaderNav';
import { HeaderMobileWrapper, LoginWrapper } from './HeaderMobile.style';

export const HeaderMobile = ({
  open,
  navigation,
  setOpen,
  useServiceOsAuth,
  basketButtonText,
  basketData,
}: THeaderMobileProps) => {
  return (
    <HeaderMobileWrapper open={open}>
      <HeaderNav navigation={navigation} setOpen={setOpen} />
      {useServiceOsAuth && (
        <HeaderBasket
          basketData={basketData}
          basketButtonText={basketButtonText}
          showOnMobile
          fullWidth
          useServiceOsAuth={useServiceOsAuth}
        />
      )}
    </HeaderMobileWrapper>
  );
};
